import type { SurveySummary } from '@/types/residents/corkBoard';

/**
 * Counts surveys that still need the resident's attention: open (not closed,
 * not past expiry) and not yet responded to by the current resident.
 *
 * The backend's `isClosed` already folds in expiry at fetch time, but the
 * expiry re-check here keeps a cached threads response from counting a survey
 * that lapsed since it was fetched.
 *
 * Used by the home Quick Actions badge; `now` is injectable for tests.
 */
export function countSurveysAwaitingResponse(
  threads: { survey?: SurveySummary }[] | undefined,
  now: number = Date.now(),
): number {
  return (threads ?? []).filter((t) => {
    const s = t.survey;
    if (!s || s.isClosed || s.hasResponded) return false;
    if (s.expiresAt && new Date(s.expiresAt).getTime() <= now) return false;
    return true;
  }).length;
}
